/* eslint-disable react/display-name */
import React from 'react';
import {
  Flex,
  IconButton,
  Icon,
  icons,
  Heading,
} from '@tapresearch/ui/components';
import ReactModal from 'react-modal';
import styled from 'styled-components';

const Modal = styled(ReactModal)`
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '450px')};
  margin: 70px auto;
  background: #fff;
  box-shadow: 0 0 30px #444;
  border-radius: 5px;
`;

const Body = styled.div`
  padding: 0 25px 25px;
`;

export default ({ isOpen, onClose, title, children, ...args }) => {
  return (
    <Modal
      {...args}
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          zIndex: 1500,
          backgroundColor: 'rgba(50, 50, 50, 0.8)',
          overflow: 'auto',
          overflowY: 'scroll',
        },
      }}
      ariaHideApp={false}
    >
      <Flex p={4} align="center" data-testid={(args || {})['data-testid']}>
        <Heading {...{ flexGrow: 1, fontSize: 'lg', fontWeight: '800' }}>
          {title}
        </Heading>
        <IconButton
          variant="ghost"
          icon={<Icon boxSize={6} icon={icons.fi.X} />}
          onClick={onClose}
        />
      </Flex>
      <Body>{children}</Body>
    </Modal>
  );
};
